exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-9d6e82be] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n[data-v-9d6e82be] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n[data-v-9d6e82be] .el-dialog__body {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n", ""]);

// exports
